export function setCookie(key: string, value: string, hours?: number) {
  let expires;
  if (hours) {
    expires = `max-age=${hours * 60 * 60};`;
  } else {
    expires = '';
  }

  document.cookie = `${key}=${value};${expires}path=/`;
}

export function getCookie(): Record<string, string>;
export function getCookie(key: string): string | undefined;

export function getCookie(key?: string): Record<string, string> | string | undefined {
  const cookie = decodeURIComponent(document.cookie);
  const cookieRows = cookie.split(';');
  const cookies = cookieRows
    .filter((c) => !!c)
    .reduce((accumulator: Record<string, string>, row) => {
      const [k, v] = row.trim().split('=');
      accumulator[k] = v;
      return accumulator;
    }, {});

  if (key) {
    return cookies[key];
  }
  return cookies;
}

export function deleteCookie(key: string) {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
